import {createReminderNamespace} from '../craft/reminders.js';
const SOURCE='dymistrz-live';
const ROUTE='#/smokings';
const ID_BASE=210_000_000;
const ID_RANGE=9_000_000;
const MAX_TEMPERATURE_REMINDERS=16;
const TEMP_HORIZON_MS=8*60*60*1000;

const namespace=createReminderNamespace({source:SOURCE,min:ID_BASE,size:ID_RANGE,keyLabel:'notification key'});
export const liveNotificationId=namespace.id;
export const isDymistrzLiveNotification=namespace.owns;

function date(value,label){
  const millis=Date.parse(String(value||''));
  if(Number.isNaN(millis))throw new TypeError(label+' must be a valid ISO timestamp');
  return millis;
}

function nowMillis(now){
  const raw=typeof now==='function'?now():now;
  if(raw instanceof Date)return raw.getTime();
  if(typeof raw==='number'&&Number.isFinite(raw))return raw;
  return date(raw,'now');
}

function plannedEnd(session,stageTarget){
  const duration=Number(stageTarget?.plannedDurationMinutes);
  if(!Number.isInteger(duration)||duration<1)return null;
  return date(session.activeStageStartedAt,'activeStageStartedAt')+duration*60_000;
}

function notification({
  id,
  kind,
  at,
  body,
  allowWhileIdle=false
}){
  return Object.freeze({
    id,
    title:'Dymistrz',
    body,
    schedule:Object.freeze({
      at:new Date(at),
      allowWhileIdle,
      isExactNotification:false
    }),
    extra:Object.freeze({
      source:SOURCE,
      route:ROUTE,
      kind
    })
  });
}

export function createLiveNotificationPlan({
  session,
  stageTarget=null,
  preferences,
  now=Date.now
}={}){
  if(!session||typeof session!=='object')throw new TypeError('session is required');
  if(session.status!=='smoking')return Object.freeze([]);
  if(!session.activeStageId)throw new TypeError('activeStageId is required');
  const prefs=preferences||{};
  if(prefs.enabled!==true)return Object.freeze([]);

  const current=nowMillis(now);
  const start=date(session.activeStageStartedAt,'activeStageStartedAt');
  const end=plannedEnd(session,stageTarget);
  const desired=[];

  if(prefs.stageEndEnabled!==false&&end!=null&&end>current){
    const leadMinutes=Number.isInteger(Number(prefs.stageEndLeadMinutes))
      ?Math.max(0,Math.min(30,Number(prefs.stageEndLeadMinutes)))
      :5;
    const leadAt=end-leadMinutes*60_000;
    const at=leadAt>current?leadAt:end;
    desired.push(notification({
      id:liveNotificationId('stage-end:'+session.id+':'+session.activeStageId),
      kind:'stage_end',
      at,
      body:leadAt>current&&leadMinutes>0
        ?'Bieżący etap zbliża się do zaplanowanego końca.'
        :'Zaplanowany czas bieżącego etapu właśnie się kończy.',
      allowWhileIdle:true
    }));
  }

  const interval=Number(prefs.temperatureIntervalMinutes);
  if([15,30,60].includes(interval)){
    const intervalMs=interval*60_000;
    const hardCutoff=current+TEMP_HORIZON_MS;
    const cutoff=end==null?hardCutoff:Math.min(end,hardCutoff);
    let slot=Math.floor(Math.max(0,current-start)/intervalMs)+1;

    while(desired.filter(item=>item.extra.kind==='temperature_check').length<MAX_TEMPERATURE_REMINDERS){
      const at=start+slot*intervalMs;
      if(at<=current){slot+=1;continue;}
      if(at>cutoff)break;
      desired.push(notification({
        id:liveNotificationId(
          'temperature:'+session.id+':'+session.activeStageId+':'+interval+':'+slot
        ),
        kind:'temperature_check',
        at,
        body:'Sprawdź temperaturę podczas trwającego wędzenia.',
        allowWhileIdle:false
      }));
      slot+=1;
    }
  }

  const ids=new Set();
  for(const item of desired){
    if(ids.has(item.id))throw new Error('LIVE_NOTIFICATION_ID_COLLISION');
    ids.add(item.id);
  }

  return Object.freeze(desired.sort((a,b)=>a.schedule.at-b.schedule.at||a.id-b.id));
}

export const LIVE_NOTIFICATION_ID_RANGE=Object.freeze({
  min:ID_BASE,
  maxExclusive:ID_BASE+ID_RANGE
});
